export enum DateOfServiceRequirementOverride {
  Disabled = 'disabled',
  Optional = 'optional',
  Required = 'required',
}
